import { useEffect } from "react";
import { Input, Form } from "antd";
import { IImagenInput } from "../BusquedaImagenes";
import ButtonLiderar from "../../ButtonLiderar/ButtonLiderar";
import "./style.less";

interface SearchFormProps {
  getImagenes: (values: IImagenInput) => void;
  clearButton: boolean;
  cleanSearch: () => void;
  onClick?: () => void;
  hideTitle?: boolean;
  formValuesOnLoad?: any;
}

const SearchForm: React.FC<SearchFormProps> = (props) => {
  const {
    getImagenes,
    clearButton,
    cleanSearch,
    onClick,
    formValuesOnLoad,
  } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    if (formValuesOnLoad) {
      form.setFieldsValue({ patente: formValuesOnLoad });
      setTimeout(() => {
        form.submit();
      }, 0);
    }
  }, [form, formValuesOnLoad]);

  return (
    <div className="SearchForm">
      <Form
        name="search_imagen"
        layout="vertical"
        className="form-get-imagen"
        initialValues={{
          patente: "",
        }}
        form={form}
        onFinish={getImagenes}
      >
        <Form.Item
          className="formItem"
          label="Patente"
          name="patente"
          rules={[{ required: true, message: "Ingrese patente" }]}
        >
          <Input
            aria-label="valor para buscar imágenes"
            className="inputForm"
            placeholder="NVY332"
            maxLength={12}
            allowClear={true}
          />
        </Form.Item>

        <div className="form-buttons">
          {clearButton ? (
            <ButtonLiderar
              color="white"
              onClick={cleanSearch}
              buttonName="Limpiar búsqueda"
              className="clean-form-button form-button"
              minWidth={"fit-content"}
              flex={1}
              margin={0}
            />
          ) : (
            <div style={{ flex: 1, padding: 5, marginRight: 8 }} />
          )}
          <ButtonLiderar
            color="violet"
            buttonName="Buscar"
            className="form-button search-button"
            htmlType="submit"
            minWidth={100}
            onClick={onClick}
            margin={0}
            flex={1}
          />
        </div>
      </Form>
    </div>
  );
};

export default SearchForm;
